import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>Ta-Da AI HR</h1>
          <p>Attendance & Leave Management</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-control" type="email" required
              value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com"/>
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-control" type="password" required
              value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"/>
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{ width:'100%', justifyContent:'center', marginTop:8 }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p className="text-center mt-16 text-sm text-muted">
          No account? <Link to="/register" style={{color:'var(--primary)'}}>Register here</Link>
        </p>
        <p className="text-center mt-16 text-sm text-muted" style={{fontSize:11}}>
          Default admin: admin@tadaindia.com / Admin@123
        </p>
      </div>
    </div>
  );
}
